export { default } from './Information';
export { type SegmentProperties } from './Information';
